export const KEYCODE = {
  TAB: 9, // no tab in CHL
  RETURN: 13, // ENTER
  ESC: 27,
  SPACE: 32,
  PAGEUP: 33,
  PAGEDOWN: 34,
  END: 35,
  HOME: 36,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,

  SHIFT: 15 // what is shift used for?
};

export const classes = {
  active: 'is-active',
  currentMenuItem: 'current-menu-item',
  navisopen: 'nav-is-open',
  navdropdownisopen: 'nav-dropdown-is-visible',
  searchisopen: 'search-is-open',
  searchisanimating: 'search-is-animating'
};

export const BREAKPOINT = {
  XS: 480,
  SM: 768,
  MD: 992,
  LG: 1200,
  XLG: 1600
};

export const TRACKING_OPTIONS = {
  headingSelectors: 'h1, h2, h3, h4, h5, .u-h1, .u-h2, .u-h3',
  sectionSelectors: 'section, footer, .o-container',
  visibilityTracking: {
    disabled: true,
  },
  button: {
    disabled: false,
    selector: 'button:not([data-remodal-target])',
  },
  accordion: {
    disabled: false,
    selector: 'clover-accordion-heading',
  },
  carousel: {
    disabled: false,
    selector: '.c-slider__arrows',
  },
  filter: {
    disabled: false,
    selector: '[data-js-filter]',
  },
  menu: {
    disabled: false,
    selector: '.c-nav-primary__hamburger, [data-js-nav-link-level1="data-js-nav-link-level1"]',
  },
  modal: {
    disabled: false,
    selector: '[data-remodal-target]',
  },
	anchor: {
    disabled: false,
    selector: 'a[href^="#"]:not([data-js-filter], [data-remodal-target])',
  },
  formTracking: {
    disabled: false,
    selector: 'form',
    nameFieldSelector: '[name="form-name"]',
    errorFieldSelector: '.form__error, .form-error',
    additionalFields: [
      {
        name: 'newsletter-signup',
        selector: '[name="newsletter[]"]'
      }
    ]
  }
};
